import React, { useEffect, useState } from "react";
import QRCode from "qrcode";
import Timer from "../Timer";
import Loader from "react-loader-spinner";
import "../Android/Styles.css";
import { labels } from "../Android/constant";


const GenerateQR = ({ data = {}, setScreen,checkStatus, getUpiLink, clearVpa, hideCollectFlow }) => {
  const [qrLink, setQrLink] = useState("");
  const [generatingQR, setGeneratingQR] = useState(false);
  const [intentFailed, setIntentFailed] = useState(false);

  const generateQr = () => {
    clearVpa(true);
    setGeneratingQR(true);
    getUpiLink();
  };

  useEffect(() => {
    if (data?.deep_link) {
      setGeneratingQR(false);     
      hideCollectFlow(true);
      QRCode.toDataURL(data?.deep_link)
      .then((url) => {
        setQrLink(url);
        })
        .catch((err) => {
          console.log("caught error while generating QR");
          console.error(err);
        });
    } else if(data.isFailure || (data.response_code && data.response_code !== 1)) {
      setGeneratingQR(false);
      setIntentFailed(true);
    }
  },[data, checkStatus, generatingQR])

  return (
    <>
      <h2>Enter your UPI Details</h2>
      <div className="generate-qr-container">
        {qrLink.length ? (
          <h6>{labels.SCAN_QR_CODE}</h6>
        ) : (
          <h5>{labels.PAY_BY_ANY_UPI_APP}</h5>
        )}
        <img
          className="upi-options"
          src={`../../${process.env.PUBLIC_URL}/images/upi_options.svg`}
          alt="upi options"
        />
        {qrLink.length ? (
          <img width={164} height={164} src={qrLink} alt="qr-code" />
        ) : (
          <div className="qrWrapper">
            <div
              onClick={generateQr}
              className={`generate-qr-code ${
                generatingQR ? "disabled-qr-code" : ""
              }`}
              tabIndex={-1}
              role="button"
            >
              {generatingQR ? <Loader type="Oval" color='var(--primary-theme-color)' height={20} width={30} /> : "Generate QR Code"}
            </div>
            {intentFailed && <div className="intentErrorWapper">{labels.PROCESS_PAYMENT_ERROR}</div>}
          </div>
        )}
        {qrLink.length > 0 && (
          <>
            <img
              src={`../../${process.env.PUBLIC_URL}/images/upi-icon.svg`}
              alt="powered-by"
            />
            <Timer
              frontText="This QR code is valid for"
              endText="minutes"
              callback={() => {
                setScreen("TIMER_PROCESSING");
              }}
              checkStatus={checkStatus}
            />
          </>
        )}
      </div>
    </>
  );
};

export default GenerateQR;
